import { EXPLORE_OTHER_CARD_TYPES_EXPERIMENT_NAME } from './explore-other-card-types/constants';
import type {
  FunnelExperimentConfig,
  JumpPageExperimentConfig,
  PrimaryGoalExperimentConfig,
  RecommendationsExperimentConfig,
} from './types';

export const STATIC_EXPERIMENTS: (
  | PrimaryGoalExperimentConfig
  | FunnelExperimentConfig
  | JumpPageExperimentConfig
  | RecommendationsExperimentConfig
)[] = [
  /*
  Disabled: credit score first is not currently running as a static experiment
  { pageType: 'primary-goal', name: CREDIT_SCORE_FIRST_EXPERIMENT_NAME },
  {
    pageType: 'funnel',
    name: CREDIT_SCORE_FIRST_EXPERIMENT_NAME,
    slugs: CREDIT_SCORE_FIRST_EXPERIMENT_SLUGS,
  },
  { pageType: 'recommendations', name: CREDIT_SCORE_FIRST_EXPERIMENT_NAME },
  */
  { pageType: 'funnel', name: EXPLORE_OTHER_CARD_TYPES_EXPERIMENT_NAME },
];
